import { Component, Input, OnInit } from '@angular/core';
import { ActiveBrandService } from '@go-modules/services/active-brand';

@Component({
	selector: 'quick-start-guide',
	templateUrl: './quick-start-guide.component.html',
	styleUrls: ['./quick-start-guide.component.scss'],
	standalone: false
})
export class QuickStartGuideComponent implements OnInit {
	@Input() public lmsName: string;

	public constructor (private activeBrandService: ActiveBrandService) {}

	public get translationParams () {
		return this.activeBrandService.getTranslationParams();
	}

	public get quickStartTranslationParams () {
		return { ...this.translationParams, lmsName: this.lmsName };
	}

	public ngOnInit () {
		this.lmsName = this.lmsName
			.split(' ')
			.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
			.join(' ');
	}
}
